import {
  CLEAR_STUDENT_ABSENCES_AND_RELATIVES,
  GET_STUDENT_RELATIVES,
  GET_STUDENT_RELATIVES_FAILURE,
  GET_STUDENT_RELATIVES_SUCCESS,
  LOAD_MORE_PAST_STUDENTS_ABSENCES_FAILURE,
  LOAD_MORE_PAST_STUDENTS_ABSENCES_SUCCESS,
  SEARCH_PAST_STUDENT_ABSENCES,
  SEARCH_PAST_STUDENT_ABSENCES_FAILURE,
  SEARCH_PAST_STUDENT_ABSENCES_SUCCESS,
  SEARCH_UPCOMING_STUDENT_ABSENCES,
  SEARCH_UPCOMING_STUDENT_ABSENCES_FAILURE,
  SEARCH_UPCOMING_STUDENT_ABSENCES_SUCCESS,
  SEARCH_LOCATION_REQUESTS_HISTORY,
  SEARCH_LOCATION_REQUESTS_HISTORY_FAILURE,
  SEARCH_LOCATION_REQUESTS_HISTORY_SUCCESS,
  LOAD_MORE_LOCATION_REQUESTS,
  LOAD_MORE_LOCATION_REQUESTS_FAILURE,
  LOAD_MORE_LOCATION_REQUESTS_SUCCESS,
  REMOVE_ABSENCE,
  STOP_ABSENCE,
  EDIT_ABSENCE,
  CREATE_ABSENCE,
  CREATE_ABSENCE_SUCCESS,
  EDIT_ABSENCE_SUCCESS,
  REMOVE_ABSENCE_SUCCESS,
  STOP_ABSENCE_SUCCESS,
  START_STUDENT_LOADING,
  STOP_STUDENT_LOADING,
  CLEAR_STUDENTS_REDUCER,
  GET_STUDENT_LOCATION_SUCCESS,
  SET_STUDENT_LOCATION_LOADING,
  GET_INSURANCES_SUCCESS,
  LOAD_ABSENCE_REASONS_SUCCESS,
  TOGGLE_ABSENCE_MODAL,
  ABSENCE_PENDING_FAILURE,
  UPLOAD_AVATAR,
  UPLOAD_AVATAR_SUCCESS,
  UPLOAD_AVATAR_ERROR,
} from '../constants/ActionTypes';

const INIT_STATE = {
  absenceReasons: [],
  absences: {
    data: [], // for possible general purposes
    loading: false,
    isModalLoading: false,
    isAbsenceModalOpen: false,
    past: {
      currentPage: 1,
      data: [],
      loading: false,
      nextPage: 1,
      pageCount: 1,
    },
    preloadedForStudentId: null, // needed for preload purposes
    upcoming: {
      currentPage: 1,
      data: [],
      loading: false,
      nextPage: 1,
      pageCount: 1,
    },
  },
  loadingList: false,
  location: null,
  loadingLocation: false,
  filter: '',
  loading: false,
  locationRequestsHistory: {
    currentPage: 1,
    data: [],
    loading: false,
    pageCount: 1,
  },
  relatives: {
    data: { parents: [], additionals: [] },
    loading: false,
    preloadedForStudentId: null, // needed for preload purposes
  },
  studentInsurance: null,
  isAvatarUploading: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case CLEAR_STUDENT_ABSENCES_AND_RELATIVES:
      return {
        ...state,
        absences: {
          ...state.absences,
          data: [],
          past: {
            ...state.absences.past,
            currentPage: 1,
            data: [],
            loading: false,
            nextPage: 1,
            pageCount: 1,
          },
          preloadedForStudentId: null,
          upcoming: {
            ...state.absences.upcoming,
            currentPage: 1,
            data: [],
            loading: false,
            nextPage: 1,
            pageCount: 1,
          },
        },
        relatives: {
          ...state.relatives,
          data: [],
          preloadedForStudentId: null,
        },
      };
    case GET_STUDENT_RELATIVES:
      return {
        ...state,
        relatives: {
          ...state.relatives,
          loading: true,
        },
      };
    case GET_STUDENT_RELATIVES_FAILURE:
      return {
        ...state,
        relatives: {
          ...state.relatives,
          data: [],
          loading: false,
          preloadedForStudentId: null,
        },
      };
    case GET_STUDENT_RELATIVES_SUCCESS:
      return {
        ...state,
        relatives: {
          ...state.relatives,
          data: action.payload.relatives,
          loading: false,
          preloadedForStudentId: action.payload.studentId,
        },
      };
    case LOAD_MORE_PAST_STUDENTS_ABSENCES_FAILURE:
      return {
        ...state,
        absences: {
          ...state.absences,
          past: {
            ...state.absences.past,
            loading: false,
          },
        },
      };
    case LOAD_MORE_PAST_STUDENTS_ABSENCES_SUCCESS:
      return {
        ...state,
        absences: {
          ...state.absences,
          past: {
            ...state.absences.past,
            currentPage: state.absences.past.nextPage,
            data: [...state.absences.past.data, ...action.payload.absences],
            loading: false,
            nextPage: state.absences.past.nextPage + 1,
            pageCount: action.payload.pageCount,
          },
        },
      };
    case SEARCH_PAST_STUDENT_ABSENCES:
      return {
        ...state,
        absences: {
          ...state.absences,
          past: { ...state.absences.past, loading: true },
        },
      };
    case SEARCH_PAST_STUDENT_ABSENCES_FAILURE:
      return {
        ...state,
        absences: {
          ...state.absences,
          past: {
            ...state.absences.past,
            data: [],
            loading: false,
            pageCount: 1,
          },
          preloadedForStudentId: null,
        },
      };
    case SEARCH_PAST_STUDENT_ABSENCES_SUCCESS:
      return {
        ...state,
        absences: {
          ...state.absences,
          past: {
            ...state.absences.past,
            currentPage: 1,
            data: action.payload.absences,
            loading: false,
            nextPage: 2,
            pageCount: action.payload.pageCount,
          },
          preloadedForStudentId: action.payload.studentId,
        },
      };
    case SEARCH_UPCOMING_STUDENT_ABSENCES:
      return {
        ...state,
        absences: {
          ...state.absences,
          upcoming: { ...state.absences.upcoming, loading: true },
        },
      };
    case SEARCH_UPCOMING_STUDENT_ABSENCES_FAILURE:
      return {
        ...state,
        absences: {
          ...state.absences,
          preloadedForStudentId: null,
          upcoming: {
            ...state.absences.upcoming,
            data: [],
            loading: false,
            pageCount: 1,
          },
        },
      };
    case SEARCH_UPCOMING_STUDENT_ABSENCES_SUCCESS:
      return {
        ...state,
        absences: {
          ...state.absences,
          preloadedForStudentId: action.payload.studentId,
          upcoming: {
            ...state.absences.upcoming,
            data: action.payload.absences,
            loading: false,
            pageCount: action.payload.pageCount,
          },
        },
      };
    case SEARCH_LOCATION_REQUESTS_HISTORY:
    case LOAD_MORE_LOCATION_REQUESTS:
      return {
        ...state,
        locationRequestsHistory: {
          ...state.locationRequestsHistory,
          loading: true,
        },
      };
    case SEARCH_LOCATION_REQUESTS_HISTORY_FAILURE:
      return {
        ...state,
        locationRequestsHistory: {
          ...state.locationRequestsHistory,
          currentPage: 1,
          data: [],
          loading: false,
          pageCount: 1,
        },
      };
    case SEARCH_LOCATION_REQUESTS_HISTORY_SUCCESS:
      return {
        ...state,
        locationRequestsHistory: {
          ...state.locationRequestsHistory,
          currentPage: 1,
          data: action.payload.requests,
          loading: false,
          pageCount: action.payload.pageCount,
        },
      };
    case LOAD_MORE_LOCATION_REQUESTS_FAILURE:
      return {
        ...state,
        locationRequestsHistory: {
          ...state.locationRequestsHistory,
          loading: false,
        },
      };
    case LOAD_MORE_LOCATION_REQUESTS_SUCCESS:
      return {
        ...state,
        locationRequestsHistory: {
          ...state.locationRequestsHistory,
          currentPage: state.locationRequestsHistory.currentPage + 1,
          data: [...state.locationRequestsHistory.data, ...action.payload.requests],
          loading: false,
          pageCount: action.payload.pageCount,
        },
      };

    case TOGGLE_ABSENCE_MODAL: {
      return {
        ...state,
        absences: {
          ...state.absences,
          isAbsenceModalOpen: !state.absences.isAbsenceModalOpen,
        },
      };
    }
    case ABSENCE_PENDING_FAILURE: {
      return {
        ...state,
        absences: {
          ...state.absences,
          isModalLoading: false,
        },
      };
    }
    case CREATE_ABSENCE_SUCCESS: {
      // sorted in saga
      return {
        ...state,
        absences: {
          ...state.absences,
          isModalLoading: false,
          isAbsenceModalOpen: false,
        },
      };
    }
    case EDIT_ABSENCE_SUCCESS: {
      // sorted in saga
      return {
        ...state,
        absences: {
          ...state.absences,
          isModalLoading: false,
          isAbsenceModalOpen: false,
        },
      };
    }
    case START_STUDENT_LOADING: {
      return {
        ...state,
        loading: true,
      };
    }
    case STOP_STUDENT_LOADING: {
      return {
        ...state,
        loading: false,
      };
    }
    case REMOVE_ABSENCE:
    case STOP_ABSENCE:
    case EDIT_ABSENCE:
    case CREATE_ABSENCE: {
      return {
        ...state,
        absences: {
          ...state.absences,
          isModalLoading: true,
        },
      };
    }
    case REMOVE_ABSENCE_SUCCESS:
    case STOP_ABSENCE_SUCCESS: {
      const { absenceId } = action.payload;
      return {
        ...state,
        absences: {
          ...state.absences,
          isAbsenceModalOpen: false,
          isModalLoading: false,
          upcoming: {
            ...state.absences.upcoming,
            data: state.absences.upcoming.data.filter(absence => absence.id !== absenceId),
          },
        },
      };
    }
    case GET_STUDENT_LOCATION_SUCCESS: {
      return {
        ...state,
        location: action.payload.location,
      };
    }
    case SET_STUDENT_LOCATION_LOADING: {
      return {
        ...state,
        loadingLocation: action.payload.isLoading,
      };
    }
    case GET_INSURANCES_SUCCESS: {
      return {
        ...state,
        studentInsurance: action.payload.insurance,
      };
    }

    case LOAD_ABSENCE_REASONS_SUCCESS: {
      return {
        ...state,
        absenceReasons: action.payload.reasons,
      };
    }
    case UPLOAD_AVATAR: {
      return {
        ...state,
        isAvatarUploading: true,
      };
    }
    case UPLOAD_AVATAR_SUCCESS: {
      return {
        ...state,
        isAvatarUploading: false,
      };
    }
    case UPLOAD_AVATAR_ERROR: {
      return {
        ...state,
        isAvatarUploading: false,
      };
    }
    case CLEAR_STUDENTS_REDUCER:
      return INIT_STATE;
    default:
      return state;
  }
};
